import { GET_LIST_ACTION } from "../../constants";

export const getListAction = (payload: any) => {
  return {
    type: GET_LIST_ACTION,
    payload,
  };
};
